import { buildBundle as EnUsBuildBundle } from '../en-us/buildBundle';
import { AgResourceLanguage } from '../types';

export const buildBundle: AgResourceLanguage['buildBundle'] = {
  ...EnUsBuildBundle,
  headerSteps: '{{step}} van 2',
  firstStep: {
    price: 'Vanaf'
  }
};
